/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppEmbeddedSignupRetryProvisioningPathParams,
	WhatsAppEmbeddedSignupRetryProvisioningResponse,
} from '../types/WhatsAppEmbeddedSignupRetryProvisioning'

/**
 * POST /organisations/:organisationId/whatsapp-account/signup/retry-provisioning
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::retryProvisioning
 */
export async function whatsAppEmbeddedSignupRetryProvisioning(
	organisationId: WhatsAppEmbeddedSignupRetryProvisioningPathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppEmbeddedSignupRetryProvisioningResponse>> {
	return axiosInstance.post(
		`/organisations/${organisationId}/whatsapp-account/signup/retry-provisioning`,
		undefined,
		config,
	)
}
